export default __webpack_public_path__ + "static/media/L.2264b9fd.svg";